import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createCms() {
  yield takeEvery(actions.CREATE_CMS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/cms`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.CREATE_CMS_ENDED });
    }
  });
}

function* searchCms() {
  yield takeEvery(actions.SEARCH_CMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/cms?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.SEARCH_CMS_ENDED });
    }
  });
}

function* findCms() {
  yield takeEvery(actions.FIND_CMS, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/cms/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.FIND_CMS_END });
    }
  });
}

function* updateCms() {
  yield takeEvery(actions.UPDATE_CMS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/cms`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.UPDATE_CMS_ENDED });
    }
  });
}

function* updateAllCms() {
  yield takeEvery(actions.UPDATE_ALL_CMS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/cms/agreeEnableReviewCms`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_ALL_CMS_ENDED });
    }
  });
}

function* archiveAllCms() {
  yield takeEvery(actions.ARCHIVE_ALL_CMS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/cms/archiveCms`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.ARCHIVE_ALL_CMS_ENDED });
    }
  });
}

function* deleteCms() {
  yield takeEvery(actions.DELETE_CMS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/cms`, {
        data,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.DELETE_CMS_ENDED });
    }
  });
}

function* createCmsCategory() {
  yield takeEvery(actions.CREATE_CMS_CATEGORY, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/cms/category`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms', 'createCmsCategory');
    } finally {
      yield put({ type: actions.CREATE_CMS_CATEGORY_ENDED });
    }
  });
}

function* searchCmsCategories() {
  yield takeEvery(actions.SEARCH_CMS_CATEGORY, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/cms/category?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.SEARCH_CMS_CATEGORY_ENDED });
    }
  });
}

function* findCmsCategory() {
  yield takeEvery(actions.FIND_CMS_CATEGORY, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/cms/category/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.FIND_CMS_CATEGORY_END });
    }
  });
}

function* updateCmsCategory() {
  yield takeEvery(actions.UPDATE_CMS_CATEGORY, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/cms/category`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms', 'updateCmsCategory');
    } finally {
      yield put({ type: actions.UPDATE_CMS_CATEGORY_ENDED });
    }
  });
}

function* deleteCmsCategories() {
  yield takeEvery(actions.DELETE_CMS_CATEGORY, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/cms/category`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err, 'cms');
    } finally {
      yield put({ type: actions.DELETE_CMS_CATEGORY_END });
    }
  });
}

function* batchUpdateCmsWeight() {
  yield takeEvery(actions.BATCH_UPDATE_CMS_WEIGHT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/cms/batchUpdateCmsWeight`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.BATCH_UPDATE_CMS_WEIGHT_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createCms),
    fork(searchCms),
    fork(findCms),
    fork(updateCms),
    fork(updateAllCms),
    fork(archiveAllCms),
    fork(deleteCms),
    fork(createCmsCategory),
    fork(searchCmsCategories),
    fork(findCmsCategory),
    fork(updateCmsCategory),
    fork(deleteCmsCategories),
    fork(batchUpdateCmsWeight),
  ]);
}
